import { render, staticRenderFns } from "./buttonExtractionForSalesBB.vue?vue&type=template&id=45c56e8f&scoped=true&"
import script from "./buttonExtractionForSalesBB.vue?vue&type=script&lang=js&"
export * from "./buttonExtractionForSalesBB.vue?vue&type=script&lang=js&"
import style0 from "./buttonExtractionForSalesBB.vue?vue&type=style&index=0&id=45c56e8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c56e8f",
  null
  
)

export default component.exports